module.exports = __webpack_public_path__ + "img/30.78095be9.jpg";